// extracted by mini-css-extract-plugin
export default {"cell-container":"CellDeployModuleVersion_cell-container__KriH3"};